import { createReducer, createAction } from '@reduxjs/toolkit'

export interface Brand {
  id: number
  name: string
  rails_app_id: number
}

export interface BrandsReducer {
  brands: Brand[]
  loading: boolean
  error: boolean
}

const initialState: BrandsReducer = {
  brands: [],
  loading: false,
  error: false
}

interface FetchBrandsSuccessPayload {
  brands: Brand[]
}

export const FETCH_BRANDS = createAction('brands_reducer/fetch_brands')
export const FETCH_BRANDS_SUCCESS = createAction<FetchBrandsSuccessPayload>('brands_reducer/fetch_brands_success')
export const FETCH_BRANDS_FAILURE = createAction('brands_reducer/fetch_brands_failure')

export const brandsReducer = createReducer(initialState, (builder) => {
  builder.addCase(FETCH_BRANDS, (state) => {
    return { ...state, loading: true, error: false }
  })
  builder.addCase(FETCH_BRANDS_SUCCESS, (state, action) => {
    return {
      ...state,
      brands: action.payload.brands,
      loading: false,
      error: false
    }
  })
  builder.addCase(FETCH_BRANDS_FAILURE, (state) => {
    return { ...state, brands: [], loading: false, error: true }
  })
})
